import React, { useEffect, useRef } from "react";
import { parseWall } from "./levels";
import { drawField, WallLayer } from "./renderer";
import { COLS, ROWS } from "./world";

// Level 2 mid-game, from the design's card picture: a tunnel through the middle, one golden brick
// left, two black bricks cracked, the ball on its way up.
const WALL = parseWall({ top: 1, rows: ["Y.YY.Y", "RRkRKRR", "BBO.BB", "GK...kG", "Y....Y", "R.....R", "kB..BK"] });

/** Static picture of a Brick Breaker field for the landing card (no game code). */
function FieldThumb({ cell }: { cell: number }) {
  const canvas = useRef<HTMLCanvasElement>(null);

  useEffect(() => {
    const cv = canvas.current;
    const ctx = cv?.getContext("2d");
    if (!cv || !ctx) return;
    const dpr = window.devicePixelRatio || 1;
    cv.width = Math.round(COLS * cell * dpr);
    cv.height = Math.round(ROWS * cell * dpr);
    ctx.setTransform(dpr, 0, 0, dpr, 0, 0);
    drawField(
      ctx,
      {
        bricks: WALL,
        wallVersion: 0,
        ball: { x: 5.3, y: 9.3 },
        paddle: 2.9,
        serving: false,
        aim: 0,
        trail: [
          { x: 4.62, y: 10.18 },
          { x: 3.94, y: 11.06 },
          { x: 3.26, y: 11.94 },
        ],
        scene: { pops: [{ x: 8.4, y: 6.6, text: "+10", gold: false, age: 0.1 }], chips: [] },
      },
      cell,
      0.6,
      new WallLayer(),
      dpr,
      true,
    );
  }, [cell]);

  return (
    <div className="field-thumb">
      <canvas
        ref={canvas}
        style={{ width: COLS * cell, height: ROWS * cell, display: "block", borderRadius: 4 }}
        aria-hidden
      />
    </div>
  );
}

export default FieldThumb;
